<template>
  <div class="asc-grid-drill-down-read-cell">
    <template v-if="isIdUnread">
      <asc-icon
        icon="circle"
        :color="getIconColor"
        :size="9"
        class="asc-icon"
      ></asc-icon>
      <span class="asc-value asc-value-bold">{{ value }}</span>
    </template>
    <template v-if="!isIdUnread">
      <span class="asc-value">{{ value }}</span>
    </template>
  </div>
</template>

<script>
import AscIcon from '@/components/atoms/AscIcon'
import { isDate1AndDate2LessThanDays } from '@/utilities/dates'
import variables from '@/styles/_varsJs.scss'

export default {
  name: 'AscGridDrillDownReadCell',

  components: {
    AscIcon,
  },

  props: {
    value: {
      type: [String, Number],
      default: '',
    },
    localStorageName: {
      type: String,
      default: '',
    },
    updateDate: {
      type: [Date, String],
      required: true,
    },
  },

  computed: {
    getIconColor() {
      return variables.accent700
    },
    isIdUnread() {
      const key = localStorage.getItem(this.localStorageName)
      if (key) {
        const items = JSON.parse(key)
        const filteredItems = items.filter(
          item =>
            item.id === this.value &&
            new Date(item.date).getTime() ===
              new Date(this.updateDate).getTime(),
        )
        if (filteredItems.length > 0) {
          return false
        }
        return isDate1AndDate2LessThanDays(this.updateDate, new Date(), 120)
      }
      return isDate1AndDate2LessThanDays(this.updateDate, new Date(), 120)
    },
  },

  methods: {
    isValidDate(date) {
      return new Date(date).getTime()
    },
  },
}
</script>

<style lang="scss">
.asc-grid-drill-down-read-cell {
  display: flex;
  justify-items: center;

  & .asc-icon {
    margin-right: 8px;
  }

  & .asc-value {
    color: $accent-700;

    &:hover {
      text-decoration: underline;
    }
  }

  & .asc-value-bold {
    font-weight: 500;
  }
}
</style>
